export function containerSpecMemoryLimitBytes ({ name, id, } = {}, datasource) {
    switch (datasource) {
    default:
        return `max(container_spec_memory_limit_bytes{kubernetes_pod_name="${name}", kubernetes_namespace="${id}", container=~".+"})`
    }
}

export function xpandContainerRoew ({ name, id, } = {}, datasource) {
    switch (datasource) {
    default:
        return `avg(rate(mariadb_xpand_containers_rows{kubernetes_pod_name=~"${name}", kubernetes_namespace="${id}"}[300s])) by (kubernetes_pod_name, op)`
    }
}
